import { SERVICES, CITIES, PHONE, PHONE_TEL, WA, EMAIL, ADDRESS, CNPJ } from "../data";

const MAP_EMBED =
  "https://www.google.com/maps?q=R.%20das%20Maritacas%2C%20831%2C%20Maresias%2C%20S%C3%A3o%20Sebasti%C3%A3o%20-%20SP%2C%2011628-649&output=embed";

export const MapSection = () => (
  <section className="section" data-testid="map-section">
    <div className="container">
      <span className="section-tag">Localização</span>
      <h2>Nossa base em Maresias — São Sebastião</h2>
      <p>{ADDRESS}. Equipes posicionadas pelo litoral norte, centro e sul para chegar mais rápido até você.</p>
      <div className="map-wrap">
        <iframe
          src={MAP_EMBED}
          title="Mapa — Desentope Maresias, R. das Maritacas 831, Maresias, São Sebastião SP"
          loading="lazy"
          width="1100"
          height="360"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="footer" data-testid="footer">
    <div className="container">
      <div className="footer-grid">
        <div className="f-brand">
          <img src="/img/logo.webp" alt="Desentope Maresias 24 Horas" loading="lazy" width="140" height="46" />
          <p>
            Desentupidora 24 horas no litoral de São Paulo. Emergência, hidrojateamento,
            limpeza de fossa e caixa de gordura em todas as praias — de Peruíbe a Ubatuba.
          </p>
          <p><strong style={{ color: "#fff" }}>CNPJ:</strong> {CNPJ}</p>
        </div>
        <div>
          <h4>Serviços</h4>
          <ul>
            {SERVICES.map((s) => (
              <li key={s.slug}><a href={`/servicos/${s.slug}.html`}>{s.name}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <h4>Atendimento</h4>
          <ul>
            {CITIES.map((c) => (
              <li key={c.slug}><a href={`/praias/desentupidora-${c.slug}.html`}>Desentupidora {c.name}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <h4>Contato</h4>
          <ul className="f-contact">
            <li>📞 <a href={`tel:${PHONE_TEL}`} data-testid="footer-phone-link">{PHONE}</a></li>
            <li>💬 <a href={WA} rel="noopener noreferrer" target="_blank" data-testid="footer-whatsapp-link">WhatsApp 24 horas</a></li>
            <li>✉️ <a href={`mailto:${EMAIL}`}>{EMAIL}</a></li>
            <li>📍 {ADDRESS}</li>
            <li>🕐 Atendimento 24h — todos os dias, incluindo feriados</li>
          </ul>
          <h4 style={{ marginTop: 20 }}>Institucional</h4>
          <ul>
            <li><a href="/sobre.html">Sobre a Desentope Maresias</a></li>
            <li><a href="/cidades/desentupidora-litoral-paulista.html">Desentupidora no Litoral Paulista</a></li>
            <li><a href="/blog/">Blog</a></li>
            <li><a href="/contato.html">Contato</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        © 2026 Desentope Maresias — Desentupidora 24 horas no litoral de São Paulo. Todos
        os direitos reservados. | <a href="/sitemap.xml">Sitemap</a>
      </div>
    </div>
  </footer>
);

export const FloatWhatsApp = () => (
  <div className="mobile-float-bar" data-testid="mobile-floating-contact-bar">
    <a className="mobile-float-btn mobile-float-phone" href={`tel:${PHONE_TEL}`} aria-label="Ligar agora">
      <span className="mobile-float-main"><span aria-hidden="true">☎</span>Ligar Agora</span>
      <span className="mobile-float-sub">Atendimento 24h</span>
    </a>
    <a className="mobile-float-btn mobile-float-wa" href={WA} rel="noopener noreferrer" target="_blank" aria-label="Falar no WhatsApp agora">
      <span className="mobile-float-main"><span aria-hidden="true">☘</span>WhatsApp</span>
      <span className="mobile-float-sub">Orçamento Rápido</span>
    </a>
  </div>
);
